import { render, staticRenderFns } from "./3DModel.vue?vue&type=template&id=626eb6e5&scoped=true&"
import script from "./3DModel.vue?vue&type=script&lang=js&"
export * from "./3DModel.vue?vue&type=script&lang=js&"
import style0 from "./3DModel.vue?vue&type=style&index=0&id=626eb6e5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626eb6e5",
  null
  
)

export default component.exports